import React from "react";
import SEO from "../components/SEO";

const Information = () => {
  return (
    <section className="information-page" style={{ padding: "110px 20px 60px", maxWidth: "900px", margin: "0 auto" }}>
      <SEO
        title="Product Information & Ordering Guide"
        description="Specifications, custom collage details, hand sanitizer options, and care instructions for Star.Ryhwa handcrafted products."
        canonicalUrl="/information"
      />
      <h1 style={{ fontSize: "2.25rem", color: "#111827", textAlign: "center", marginBottom: "12px", fontWeight: "700", letterSpacing: "-0.01em" }}>
        Product & Customization Guidelines
      </h1>
      <p style={{ textAlign: "center", color: "#4b5563", fontSize: "1rem", marginBottom: "36px" }}>
        Overview of our handcrafted custom products, specifications, and ordering details.
      </p>

      <div style={{ display: "grid", gap: "24px" }}>
        {/* Custom Collages */}
        <div style={{ background: "#ffffff", padding: "24px", borderRadius: "12px", border: "1px solid #e5e7eb", borderLeft: "4px solid #111827" }}>
          <h2 style={{ color: "#111827", fontSize: "1.35rem", marginTop: 0, marginBottom: "8px", fontWeight: "600" }}>
            Custom K-Pop Album Collages
          </h2>
          <p style={{ color: "#374151", fontSize: "0.95rem", lineHeight: "1.5" }}>
            All collages are handcrafted exclusively using <strong>authentic materials from official K-Pop albums</strong>.
          </p>
          <ul style={{ color: "#4b5563", lineHeight: "1.7", paddingLeft: "20px", margin: "12px 0 0 0", fontSize: "0.9rem" }}>
            <li><strong>Custom Groups & Members:</strong> Select your specific member or request an all-member group shot.</li>
            <li><strong>Official Album Guarantee:</strong> Sourced directly from official album photobooks and inclusions.</li>
            <li><strong>Album Preference:</strong> Request a specific K-Pop album or let Lana pick a surprise album for you.</li>
          </ul>
        </div>

        {/* Custom Hand Sanitizers */}
        <div style={{ background: "#ffffff", padding: "24px", borderRadius: "12px", border: "1px solid #e5e7eb", borderLeft: "4px solid #111827" }}>
          <h2 style={{ color: "#111827", fontSize: "1.35rem", marginTop: 0, marginBottom: "8px", fontWeight: "600" }}>
            Custom Hand Sanitizer Keychains
          </h2>
          <p style={{ color: "#374151", fontSize: "0.95rem", lineHeight: "1.5" }}>
            Refillable spray sanitizer keychains paired with custom character charms and whip detail (*bottles come empty).
          </p>
          <ul style={{ color: "#4b5563", lineHeight: "1.7", paddingLeft: "20px", margin: "12px 0 0 0", fontSize: "0.9rem" }}>
            <li><strong>Character Themes:</strong> Features Pokémon, KDH (K-Pop Demon Hunters), Labubu, BT21, One Piece, Sailor Moon, Stray Kids/SKZOO, and custom requests.</li>
            <li><strong>Color Case Selection:</strong> Select from Purple, Pink, Orange, Yellow, Blue, or Green cases.</li>
          </ul>
        </div>

        {/* Packaging & Shipping */}
        <div style={{ background: "#ffffff", padding: "24px", borderRadius: "12px", border: "1px solid #e5e7eb", borderLeft: "4px solid #111827" }}>
          <h2 style={{ color: "#111827", fontSize: "1.35rem", marginTop: 0, marginBottom: "8px", fontWeight: "600" }}>
            Shipping & Packaging
          </h2>
          <p style={{ color: "#4b5563", lineHeight: "1.5", fontSize: "0.9rem", margin: 0 }}>
            Every item is packed in rigid protective backing or bubble wrapping to prevent damage during transit.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Information;
